import React, { useEffect, useState } from 'react'
import { useTranslate, useRecordContext } from 'react-admin'
import { pricingServices } from 'src/services/reservation/pricing/pricing.service'
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
  Skeleton
} from '@mui/material'
import {
  ShowCard
} from 'src/components/uiElements/cards/ShowCard'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import { hasLiquidation } from 'src/components/pages/sales/reservation/logic/common/hasLiquidation'
import { LiquidationPricing } from 'src/components/pages/sales/reservation/logic/common/LiquidationPricing'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'
import { formatDateTime } from '../../../business-rule/helper/formatDate'
import CloseIcon from '@mui/icons-material/Close';

const valueField = {
    display:'flex', 
    flexDirection:'row', 
    margin:'10px', 
    justifyContent:'space-between', 
    width:'45%', 
    borderBottomColor:'lightgray', 
    borderBottomStyle:'solid', 
    borderBottomWidth:'1px'
}

export const HistoryCostsDialog = () => {
    const record = useRecordContext()
    const translate = useTranslate()
    const [pricingList, setPricingList] = useState([])
    const [updateUser, setUpdateUser] = useState('')
    const [historicalRecord, setHistoricalRecord] = useState()
    const [seeRetailLiq, setSeeRetailLiq] = useState(false)
    const [pricingIsLoading, setPricingIsLoading] = useState(false)
    const [specificPricingIsLoading, setSpecificPricingIsLoading] = useState(false)

    const getPricingById = async () =>{
        setPricingIsLoading(true)
        await pricingServices.get_pricing_version(record.pricing_relation[0].id).then((res)=>{
            setPricingList(res?.reverse())
        }).catch((error)=>console.log('errr', error))
        .finally(()=>{
            setPricingIsLoading(false)
        })
    }

    const isAirProduct = () =>{
        return record.product?.ref_table_detail === "air_detail"
    }

    const toLocalUTC = (date) =>{
        const auxdate = new Date(date); // Example local time
        const utcDate = new Date(auxdate.getTime() - auxdate.getTimezoneOffset() * 60000);
        return utcDate
    }

    const getSpecificPricing = async(version_id) =>{
        
        setSpecificPricingIsLoading(true)
        await pricingServices.get_pricing_version(record.pricing_relation[0].id, pricingList.length - version_id - 1).then((res)=>{
            setUpdateUser(res?.user?.username)
        }).catch((error)=>console.log('errr', error))
        .finally(()=>{
            setSpecificPricingIsLoading(false)
        })
    }

    useEffect(()=>{
        getPricingById()
    },[record])

    useEffect(()=>{
        getSpecificPricing(pricingList.length === 1 ? 0:1)
    },[pricingList])

    useEffect(()=>{
        if(pricingList.length >0){
            setHistoricalRecord(pricingList[pricingList.length === 1 ? 0:1])
        }
    },[pricingList])

    const changeHistoricalRecord = async (row, version_id) =>{
        getSpecificPricing(version_id)
        setHistoricalRecord(row)
    }


    return (
        <div style={{display:'flex' ,flexDirection:'row', justifyContent:'space-between'}}>
            <div style={{width:'100%'}}>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {/* <TableCell>{translate('transaccion')}</TableCell> */}
                                <TableCell>{translate('ra.field.updated_at')}</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {
                                pricingList?.map((row, i) => (
                                <TableRow style={{cursor:'pointer', backgroundColor:row?.transaction?.id == historicalRecord?.transaction?.id ? 'lightgrey':'white'}} key={i} onClick={()=>{changeHistoricalRecord(row,i)}}>
                                    {/* <TableCell>{row?.transaction?.id}</TableCell> */}
                                    <TableCell>{formatDateTime(toLocalUTC(row?.transaction?.issued_at))}</TableCell>
                                
                                </TableRow>
                            ))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <div style={{display:'flex', flexDirection:'column'}}>
                <div style={{display:'flex', flexDirection:'row'}}>
                    <label style={{marginRight:'5px'}}>{translate('ra.field.modify_by')}:</label>
                    <b>{specificPricingIsLoading?'':updateUser}</b>
                </div>
                <div style={{display:'flex' ,flexDirection:'row', alignSelf:'flex-start', justifyContent:'center', width:'100%' }}>
                    {hasLiquidation(historicalRecord?.liquidation_wholesaler) && (
                    <ShowCard
                    iconHeader={<AttachMoneyIcon />}
                    title={translate('ra.title.liquidation_wholesaler')}
                    variant='text'
                    optionHeigth={'liquidation'}
                    >
                    <TableContainer>
                        <Table>
                        {pricingIsLoading  || specificPricingIsLoading? (
                            <TableRow>
                                {[...Array( 1)].map((_, i) => (
                                <TableCell key={i}>
                                    <Skeleton variant='rectangular' width={'100%'} height={20} />
                                </TableCell>
                                ))}
                            </TableRow>):(
                        <TableBody>
                            <LiquidationPricing node_liquidation='liquidation_wholesaler' historical_record={historicalRecord} />
                        </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                    </ShowCard>)}
                    {hasLiquidation(historicalRecord?.liquidation_supplier) && (
                    <ShowCard
                    iconHeader={<AttachMoneyIcon />}
                    title={translate('ra.title.liquidation_supplier')}
                    variant='text'
                    optionHeigth={'liquidation'}
                    >
                    <TableContainer>
                        <Table>
                        {pricingIsLoading  || specificPricingIsLoading? (
                            <TableRow>
                                {[...Array( 1)].map((_, i) => (
                                <TableCell key={i}>
                                    <Skeleton variant='rectangular' width={'100%'} height={20} />
                                </TableCell>
                                ))}
                            </TableRow>):(
                            <TableBody>
                                <LiquidationPricing node_liquidation='liquidation_supplier' historical_record={historicalRecord} />
                            </TableBody>
                        )}
                        </Table>
                    </TableContainer>
                    </ShowCard>)}
                    {seeRetailLiq && (
                    <ShowCard
                        iconHeader={<AttachMoneyIcon />}
                        title={translate('ra.title.liquidation_retail')}
                        variant='text'
                        optionHeigth={'liquidation'}
                        >
                        <TableContainer>
                            <Table>
                            {pricingIsLoading  || specificPricingIsLoading? (
                            <TableRow>
                                {[...Array( 1)].map((_, i) => (
                                <TableCell key={i}>
                                    <Skeleton variant='rectangular' width={'100%'} height={20} />
                                </TableCell>
                                ))}
                            </TableRow>):(
                            <TableBody>
                                <div style={{textAlign:'end'}}>
                                    <CloseIcon onClick={()=>{setSeeRetailLiq(false)}} style={{cursor:'pointer'}}/>
                                </div>
                                <LiquidationPricing node_liquidation='liquidation_retail' historical_record={historicalRecord} />
                            </TableBody>
                            )}
                            </Table>
                        </TableContainer>
                    </ShowCard>
                    )}
                    
                </div>
                {!seeRetailLiq && <Button
                    onClick={() => setSeeRetailLiq(!seeRetailLiq)}
                    style={{ fontWeight: 600, textDecoration: 'underline', width:'30%', alignSelf:'center' }}
                >
                    {translate('ra.action.view_retail_liquidation')}
                </Button>}
                <label style={{margin:'15px', fontWeight:'bold'}}>{translate('ra.title.origin_values')}</label>
                <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap', margin:'15px'}}>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.additional_fare')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.additional_fare)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.comision')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.comision)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.net_price')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.net_price)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.markup')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.markup)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.fee')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.fee)}
                    </div>
                    {historicalRecord?.flexi_amnt !== null && <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.flexi_amnt')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.flexi_amnt)}
                    </div>}
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.final_price')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.final_price)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.net_agency')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.net_agency)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.commission_paid')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.commission_paid)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.commission_percentage')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.commission_percentage)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.expenses')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.expenses)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.extra_cost_amnt')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.extra_cost_amnt)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.extra_sale_amnt')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.extra_sale_amnt)}
                    </div>
                    {isAirProduct() && <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{'Fee ancillary baggage'}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.ancillary_markup_1)}
                    </div>}
                    {isAirProduct() && <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.debit')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.debit)}
                    </div>}
                    {isAirProduct() && <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.service_package')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.service_package_amnt)}
                    </div>}
                    {isAirProduct() && <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.gateway_expenses')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.installment_cost)}
                    </div>}
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.fare_amount')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.fare_amount)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.iva')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.iva)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.over_amount')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.over_amount)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.taxes_amount')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.taxes_amount)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.num_pax')}:</label>
                        {historicalRecord?.num_pax}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.num_segments')}:</label>
                        {historicalRecord?.num_segments}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.additional_cost')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.additional_cost)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.final_sale')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.final_sale)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.sale_discount')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.sale_discount)}
                    </div>
                    {isAirProduct() && <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.promo_1')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.promo_1)}
                    </div>}
                    {isAirProduct() && <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.promo_2')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.promo_2)}
                    </div>}
                    {isAirProduct() && <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.manual_ancillary_cost_amnt')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.manual_ancillary_cost_amnt)}
                    </div>}
                    {isAirProduct() && <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.manual_ancillary_sale_amnt')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.manual_ancillary_sale_amnt)}
                    </div>}
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.bad_practice')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.bad_practice)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.markup_additional')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.markup_additional)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{'Metasearch'}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.metasearch)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.fraud_review')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.fraud_rev_cost)}
                    </div>
                    
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.taxes_1')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.taxes_1)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.taxes_2')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.taxes_2)}
                    </div>
                    <div style={valueField}>
                        <label style={{fontWeight:'bold'}}>{translate('ra.field.taxes_3')}:</label>
                        {numberFormatterWithDecimalAndThousand(historicalRecord?.taxes_3)}
                    </div>
                </div>
            </div>
        </div>
    )
}
